import { DevTool } from '@hookform/devtools'
import { Control, FieldValues } from 'react-hook-form'

type Props<T extends FieldValues = FieldValues> = Readonly<{
  control: Control<T>
}>

export const FormDevtool = <T extends FieldValues = FieldValues>({
  control,
}: Props<T>) => {
  if (process.env.NODE_ENV === 'development') {
    return <DevTool control={control} placement="top-right" />
  }
  return null
}
